import { singleSelectPageConstants } from './singleSelectPage.constants'
import { ISingleSelectPageActions, ISingleSelectPageState } from './singleSelectPage.types'

export const initialSingleSelectPageState: ISingleSelectPageState = {
  isScrollEnd: false,
  options: [],
  chunkedOptions: [],
  commonOptions: [],
  filteredCommonOptions: [],
}

export function singleSelectPageReducer(
  state: ISingleSelectPageState = initialSingleSelectPageState,
  action: ISingleSelectPageActions
): ISingleSelectPageState {
  switch (action.type) {
    case singleSelectPageConstants.IS_SCROLL_END:
      return { ...state, isScrollEnd: action.isScrollEnd }
    case singleSelectPageConstants.SET_CHUNKED_OPTIONS:
      return { ...state, chunkedOptions: action.chunkedOptions }
    case singleSelectPageConstants.SET_OPTIONS:
      return { ...state, options: action.options }
    case singleSelectPageConstants.SET_FILTERED_COMMON_OPTIONS:
      return { ...state, filteredCommonOptions: action.filteredCommonOptions }
    case singleSelectPageConstants.SET_COMMON_OPTIONS:
      return { ...state, commonOptions: action.commonOptions }
    default:
      return state
  }
}
